import { Link, useLocation } from "react-router-dom";
import type { JobAnnotation } from "~/components/build/Show/lib/types";
import { preserveNonDrawerParams } from "~/components/build/Show/lib/urlForView";
import Emojify from "~/components/shared/Emojify";

function useJobUrl(jobUuid: string) {
  const { search } = useLocation();
  return preserveNonDrawerParams("", search, { jid: jobUuid, tab: "output" });
}

/**
 * The label is derived from job.name on the backend, which already
 * interpolates matrix and parallel tokens, so no special UI for matrix
 * variants is needed here.
 */
export function JobAnnotationLink({ annotation }: { annotation: JobAnnotation }) {
  const jobUrl = useJobUrl(annotation.jobUuid ?? "");
  const label = annotation.job?.label ?? "";
  const parallelIndex = annotation.job?.parallelGroupIndex;
  const showParallelIndex = typeof parallelIndex === "number";

  return (
    <div className="flex justify-start">
      <Link
        to={jobUrl}
        className="hover:text-charcoal-700 focus:text-charcoal-700 active:text-charcoal-700 mb-1 rounded-sm text-xs font-medium text-slate-900 transition-colors hover:underline focus:no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-inset active:no-underline"
      >
        {label ? (
          <span className="inline space-x-1">
            {showParallelIndex && (
              <span className="inline-block rounded-[3px] border border-current bg-white px-0.5 text-xs font-normal tabular-nums">
                #{parallelIndex + 1}
              </span>
            )}
            <Emojify text={label} />
          </span>
        ) : (
          "View job"
        )}
      </Link>
    </div>
  );
}
